import { useHttpRequest } from "../../utils"
import useCallBack, { Callbacks } from "../../utils/callback/useCallBack"
export interface LogoutFilter {
    userId: string
    refreshToken?: string
}
export const LogoutUserMutation = <T>(filter: LogoutFilter, callbacks?: Callbacks<T>) => {
    const { onSuccess, onError, onLoading } = useCallBack<any>(callbacks)

    const { postRequest } = useHttpRequest({})
    return async (dispatch: any) => {
        const logoutUser = async () => {
            try {
                const response = await postRequest(
                    `Auth/Logout`,
                    filter
                )
                const data = await response
                return data
            } catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await logoutUser()
            if (res) {
                if (res.succeeded) {
                    onSuccess(res)
                } else {
                    onError({ message: res.message, name: '' })
                }
            }
        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
